import { AnswerForType } from "@tellescope/types-models";

export const isChargebeeAnswerValue = (value: unknown): value is AnswerForType["Chargebee"] =>
  typeof value === "object" && value !== null && "url" in value && typeof value.url === "string";
